import {useEffect, useState} from 'react';
import Sandbox from "./components/sandbox/Sandbox";

import './App.css';

function App() {
  const [vpWidth, setVPWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  function handleWindowSizeChange() {
    setVPWidth(window.innerWidth);
  }

  const rootElement = document.getElementById('root');
  let activeTab;
  if (rootElement.hasAttribute('validate-html')) {
    activeTab = 'validateHtml';
  } else if (rootElement.hasAttribute('format-html')) {
    activeTab = 'formatHtml';
  } else {
    activeTab = 'testHtml'; // Default to testHtml if no attribute is present
  }

  return (
    <div className="main-container">
        <div className="sandbox-container">
          <Sandbox vpWidth={vpWidth} activeTab={activeTab}/>
        </div>
    </div>
  )
}

export default App;